import React, { useState } from 'react'
import { useTriviaAmerica } from '../../hooks/useTriviaAmerica'
//TYPES
import { type Question as QuestionType, Answer } from '../../config/types/triviaTypes'
import ProgressBar from './progressBar'
import { defPath } from '../../config/defPath'

const Question = ({ info, isLastQuestion }: { info: QuestionType, isLastQuestion:boolean }) => {
  const selectAnswer = useTriviaAmerica(state => state.selectAnswer)
  const goNextQuestion = useTriviaAmerica(state => state.goNextQuestion)
  const currentQuestion = useTriviaAmerica(state => state.currentQuestion)

  const [isSelect, setIsSelect] = useState('')
  const [isDisabled, setIsDisabled] = useState(true)

  const createHandleClick = (answerId: string) => () => {
    selectAnswer(info.id, answerId)
    setIsSelect(answerId)
    setIsDisabled(false)
  }

  const handleGoNextQuestion = () => {

    const answerSelected = info.answers.find(item => item.id === isSelect).value

    goNextQuestion()
    setIsDisabled(true)
  }

  return (
    <>
      <p className="lottery-trivia_question-title">
        {info.title}
      </p>

      <div className="lottery-trivia_question-listItem">
        {
          info.answers.map((answer: Answer, index: number) => (
            <div
              key={answer.id}
              onClick={createHandleClick(answer.id)}
              className={`lottery-trivia_question-item ${isSelect === answer.id ? 'lottery-trivia_question-item--select' : ''}`}
            >
              <span className='item-letter'>{`${String.fromCharCode(97 + index)}`}</span>
              <p className='item-text'>{answer.value}</p>
            </div>
          ))}
      </div>

      <div className="lottery-trivia_btn-container">
        <button
          className={`newBottom--smallYellow lottery-trivia_btn ${isDisabled ? 'lottery-trivia_btn-disabled' : ''}`}
          disabled={isDisabled}
          onClick={handleGoNextQuestion}>
            {isLastQuestion 
              ? "Enviar"
              : "Siguiente"
            }
            </button>
      </div>
    </>
  )
}

export const GameTrivia = () => {
  const copyAward = useTriviaAmerica(state => state.trivia.copy_award)
  const questions = useTriviaAmerica(state => state.trivia.questions)
  const currentQuestion = useTriviaAmerica(state => state.currentQuestion)
  const milliseconds = useTriviaAmerica(state => state.trivia.milliseconds)

  const questionsInfo = questions[currentQuestion];
  const isLastQuestion = currentQuestion === questions.length - 1;

  return (
    <section className='lottery-trivia_wrapper'>
      <picture className='lottery-trivia_logo'>
        <img className='lottery-trivia_logo--img' src={`${defPath}/assets/images/login/escudo.png`} alt="Logo Estadio Aguila" title="Logo Estadio Aguila" />
      </picture>
      <div className="lottery-trivia_question-title" dangerouslySetInnerHTML={{ __html: copyAward.value }}></div>
      <section className="lottery-trivia_controls">
        <ProgressBar initialMilliseconds={milliseconds}/>
        <h2 className="lottery-trivia_question-number">Pregunta {currentQuestion + 1} de {questions.length}</h2>
      </section>
      <Question info={questionsInfo} isLastQuestion={isLastQuestion}  />
    </section>
  )
}